document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    if (menu) {
      menu.hidden = !menu.hidden;
      toggle.setAttribute('aria-expanded', String(!menu.hidden));
    }
  }

  const thumb = event.target.closest('[data-product-thumb]');
  if (thumb) {
    const root = thumb.closest('[data-product-root]');
    const image = root && root.querySelector('.product-main-image');
    if (image && thumb.dataset.imageUrl) {
      image.style.opacity = '0';
      window.setTimeout(() => {
        image.src = thumb.dataset.imageUrl;
        image.srcset = '';
        image.style.opacity = '1';
      }, 120);
      root.querySelectorAll('[data-product-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
    }
  }

  const minus = event.target.closest('[data-qty-minus]');
  const plus = event.target.closest('[data-qty-plus]');
  if (minus || plus) {
    const control = event.target.closest('.quantity-control');
    const input = control && control.querySelector('[data-qty-input]');
    if (input) {
      const current = Math.max(1, parseInt(input.value || '1', 10));
      input.value = minus ? Math.max(1, current - 1) : current + 1;
    }
  }

  const cartMinus = event.target.closest('[data-cart-minus]');
  const cartPlus = event.target.closest('[data-cart-plus]');
  if (cartMinus || cartPlus) {
    const control = event.target.closest('.quantity-control');
    const input = control && control.querySelector('[data-cart-qty]');
    if (input) {
      const current = Math.max(0, parseInt(input.value || '0', 10));
      input.value = cartMinus ? Math.max(0, current - 1) : current + 1;
    }
  }
});

const money = (cents, currency) => {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-ZA', { style: 'currency', currency: currency || 'ZAR' }).format(cents / 100);
  } catch (e) {
    return `R ${(cents / 100).toFixed(2)}`;
  }
};

document.querySelectorAll('[data-product-root]').forEach((root) => {
  const jsonNode = root.querySelector('[data-product-json]');
  if (!jsonNode) return;
  let product;
  try { product = JSON.parse(jsonNode.textContent); } catch (e) { return; }

  const form = root.querySelector('[data-product-form]');
  const idInputs = Array.from(root.querySelectorAll('[data-variant-id]'));
  const stickyPrice = root.querySelector('[data-sticky-price]');
  const stickyAdd = root.querySelector('[data-sticky-add]');
  const stickyAddLabel = root.querySelector('[data-sticky-add-label]');
  const price = root.querySelector('[data-product-price]');
  const compare = root.querySelector('[data-product-compare-price]');
  const save = root.querySelector('[data-product-save]');
  const addButton = root.querySelector('[data-add-to-cart]');
  const addLabel = root.querySelector('[data-add-label]');
  const stock = root.querySelector('[data-product-stock]');
  const mainImage = root.querySelector('.product-main-image');

  const getSelectedOptions = () => Array.from(root.querySelectorAll('.variant-option')).map((fieldset) => {
    const checked = fieldset.querySelector('.variant-input:checked');
    return checked ? checked.value : null;
  });

  const updateVariant = () => {
    if (!product.variants || !product.variants.length) return;
    const selected = getSelectedOptions();
    const variant = product.variants.find((item) => item.options.every((value, index) => value === selected[index])) || product.variants[0];
    if (!variant) return;

    idInputs.forEach((input) => { input.value = variant.id; });
    const formattedPrice = money(variant.price, product.currency || window.Shopify && Shopify.currency && Shopify.currency.active);
    if (price) price.textContent = formattedPrice;
    if (stickyPrice) stickyPrice.textContent = formattedPrice;

    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (compare) {
      compare.hidden = !onSale;
      if (onSale) compare.textContent = money(variant.compare_at_price, product.currency || window.Shopify && Shopify.currency && Shopify.currency.active);
    }
    if (save) {
      save.hidden = !onSale;
      if (onSale) save.textContent = `Save ${money(variant.compare_at_price - variant.price, product.currency || window.Shopify && Shopify.currency && Shopify.currency.active)}`;
    }
    if (addButton) addButton.disabled = !variant.available;
    if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
    if (stickyAdd) stickyAdd.disabled = !variant.available;
    if (stickyAddLabel) stickyAddLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
    if (stock) stock.innerHTML = variant.available ? '<span class="stock-dot"></span> Available' : 'Sold out';

    if (variant.featured_image && variant.featured_image.src && mainImage) {
      mainImage.src = variant.featured_image.src;
      mainImage.srcset = '';
    }

    if (window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  };

  root.querySelectorAll('.variant-input').forEach((input) => input.addEventListener('change', updateVariant));
  if (form) form.addEventListener('submit', () => { if (addLabel) addLabel.textContent = 'Adding…'; });
});

/* Accessible rotating testimonial slider */
document.querySelectorAll('[data-testimonial-slider]').forEach((slider) => {
  const track = slider.querySelector('[data-slider-track]');
  const slides = Array.from(slider.querySelectorAll('[data-slider-slide]'));
  const dotsWrap = slider.querySelector('[data-slider-dots]');
  const prev = slider.querySelector('[data-slider-prev]');
  const next = slider.querySelector('[data-slider-next]');
  if (!track || slides.length < 1) return;

  let index = 0;
  let timer;
  const delay = Math.max(3000, parseInt(slider.dataset.autoplay || '5000', 10));

  const dots = slides.map((slide, i) => {
    if (!dotsWrap) return null;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `rc-slider-dot${i === 0 ? ' is-active' : ''}`;
    button.setAttribute('aria-label', `Show testimonial ${i + 1}`);
    button.addEventListener('click', () => goTo(i, true));
    dotsWrap.appendChild(button);
    return button;
  });

  const goTo = (newIndex, restart = false) => {
    index = (newIndex + slides.length) % slides.length;
    track.style.transform = `translateX(-${index * 100}%)`;
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
      slide.setAttribute('aria-hidden', String(i !== index));
    });
    dots.forEach((dot, i) => dot && dot.classList.toggle('is-active', i === index));
    if (restart) start();
  };

  const stop = () => { if (timer) window.clearInterval(timer); };
  const start = () => {
    stop();
    if (slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      timer = window.setInterval(() => goTo(index + 1), delay);
    }
  };

  prev && prev.addEventListener('click', () => goTo(index - 1, true));
  next && next.addEventListener('click', () => goTo(index + 1, true));
  slider.addEventListener('mouseenter', stop);
  slider.addEventListener('mouseleave', start);
  slider.addEventListener('focusin', stop);
  slider.addEventListener('focusout', start);
  document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
  start();
});

/* Random Co 10% email signup popup */
document.querySelectorAll('[data-email-popup]').forEach((popup) => {
  const storageKey = 'randomCoEmailPopupDismissed';
  const delay = Math.max(0, parseInt(popup.dataset.delay || '7000', 10));
  const closeButtons = popup.querySelectorAll('[data-email-popup-close]');
  const dialog = popup.querySelector('.rc-email-popup__dialog');
  const email = popup.querySelector('input[type="email"]');
  let opener = null;

  const close = () => {
    popup.hidden = true;
    document.body.classList.remove('rc-popup-open');
    try { localStorage.setItem(storageKey, '1'); } catch (e) {}
    if (opener) opener.focus();
  };
  const open = () => {
    try { if (localStorage.getItem(storageKey) === '1') return; } catch (e) {}
    opener = document.activeElement;
    popup.hidden = false;
    document.body.classList.add('rc-popup-open');
    window.setTimeout(() => email && email.focus(), 80);
  };

  closeButtons.forEach((button) => button.addEventListener('click', close));
  popup.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
    if (event.key === 'Tab' && dialog) {
      const focusables = Array.from(dialog.querySelectorAll('button,input,a[href]')).filter((el) => !el.disabled);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  window.setTimeout(open, delay);
});


/* Random Co V2.1: one lead product per browsing session */
document.querySelectorAll('[data-random-lead-product]').forEach((section) => {const cards=Array.from(section.querySelectorAll('[data-random-product-card]'));if(!cards.length)return;const key=`randomCoLeadProduct:${section.dataset.sectionId||'home'}`;let chosenHandle=null;try{chosenHandle=sessionStorage.getItem(key)}catch(e){}let chosen=cards.find((card)=>card.dataset.productHandle===chosenHandle);if(!chosen){chosen=cards[Math.floor(Math.random()*cards.length)];try{sessionStorage.setItem(key,chosen.dataset.productHandle||'')}catch(e){}}cards.forEach((card)=>{const active=card===chosen;card.hidden=!active;card.setAttribute('aria-hidden',String(!active))})});
/* Rotating top announcement */
document.querySelectorAll('[data-announcement-rotator]').forEach((bar)=>{const messages=Array.from(bar.querySelectorAll('[data-announcement-message]'));if(messages.length<2)return;let index=0;const delay=Math.max(3000,parseInt(bar.dataset.interval||'5000',10));const show=(next)=>{index=(next+messages.length)%messages.length;messages.forEach((message,i)=>{const active=i===index;message.hidden=false;message.classList.toggle('is-active',active);message.setAttribute('aria-hidden',String(!active))})};show(0);if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches)window.setInterval(()=>show(index+1),delay)});
